import React, { FC, ReactNode, useMemo } from 'react';
import { TMark } from './models';
import { ListContext } from './context';
import { Text } from '../Text';
import { ListItem } from './ListItem';
import { IDefaultComponentProps } from '@src/models/props';
import { TColor, TIconSize } from '@src/models/common';
import { classnames } from '@src/utils/classnames';
import styled from './list.scss';

interface INestedComponents {
  Item: typeof ListItem;
}

interface IProps extends IDefaultComponentProps {
  /** Заголовок */
  title?: string | ReactNode;

  /** Маркер элемента списка */
  mark: TMark;

  markColor?: TColor;

  /** Класс элемента */
  itemClassName?: string;

  markSize?: TIconSize;
}

/**
 * Компонент для отображения списков
 */
export const List: FC<IProps> & INestedComponents = ({
  mark,
  markColor,
  title,
  itemClassName,
  className,
  children,
  style,
  markSize,
}) => {
  const classes = classnames(styled.root, className);

  const value = useMemo(
    () => ({
      mark,
      itemClassName,
      markColor,
      markSize,
    }),
    [itemClassName, markColor, markSize, mark],
  );

  return (
    <ListContext.Provider value={value}>
      <div className={classes} style={style}>
        {title && (
          <Text id={'title'} weight="bold" className={styled.title}>
            {title}
          </Text>
        )}
        <ul>{children}</ul>
      </div>
    </ListContext.Provider>
  );
};

List.Item = ListItem;
